import React from 'react';
import { string } from 'prop-types';
import { Icon } from '@tesla/design-system-react';
import { iconSuccess } from '@tesla/design-system-icons';
import { useIntl } from 'react-intl';
import messages from './messages';
import style from './style.module.scss';
import formStyle from '../../containers/JobApplication/style.module.scss';

const Confirmation = ({ copy, heading, jobTitle }) => {
  const intl = useIntl();
  const { formatMessage } = intl;
  const confirmationHeading = heading || formatMessage(messages.ConfirmationMessageHeader);
  const confirmationCopy = copy || formatMessage(messages.ConfirmationMessage);

  return (
    <div
      className={`tds-layout tds-layout--constrained ${formStyle.FormLayout} ${style.Confirmation} `}
    >
      <div className={formStyle.FormLayoutItem}>
        <Icon className={style.IconSuccess} data={iconSuccess} />
        <h2 className={style.ConfirmationHeading}>
          {confirmationHeading || formatMessage(messages.ConfirmationMessageHeader)}
        </h2>
        <p className={style.JobTitle}>{jobTitle}</p>
        <p className="tds-text--h5">{formatMessage(messages.ConfirmationMessageSubHeader)}</p>
        <p className={style.ConfirmationCopy}>
          {confirmationCopy || formatMessage(messages.ConfirmationMessage)}
        </p>
      </div>
    </div>
  );
};

Confirmation.propTypes = {
  copy: string,
  heading: string,
  jobTitle: string.isRequired,
};

Confirmation.defaultProps = {
  copy: null,
  heading: null,
};

export default Confirmation;
